export enum StatusRequestEnum{
    Pending  = 'pending',
    Accepted = 'accepted',
    Rejected = 'rejected'
}


// WEBPACK FOOTER //
// ./src/utils/statusRequestEnum.ts